import LegalLayout from "@/components/LegalLayout";

export default function AGB() {
  return (
    <LegalLayout title="AGB" eyebrow="Legal · Allgemeine Geschäftsbedingungen">
      <section className="space-y-10 text-white/80 font-body text-base leading-relaxed">

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 1 Geltungsbereich
          </h2>
          <p>
            Diese Allgemeinen Geschäfts­bedingungen (AGB) gelten für alle Bestellungen, die Verbraucher und
            Unternehmer über den Online-Shop <strong>KirchHero</strong> unter{" "}
            <span className="text-white">kirchero.store</span> bei der VHP Consulting GmbH tätigen.
          </p>
          <p className="mt-3">
            Verbraucher im Sinne dieser AGB ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
            abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen
            Tätigkeit zugerechnet werden können (§ 13 BGB).
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 2 Vertragspartner
          </h2>
          <p className="whitespace-pre-line">
{`Verkäufer und Vertragspartner ist:

VHP Consulting GmbH
Geschäftsführer: Matthias Kirchner
Lützner Straße 214
04179 Leipzig
Deutschland

Telefon: +49 341 5502441
E-Mail:  kontakt@vhp-consulting.com
Handelsregister: Amtsgericht Leipzig, HRB 31253`}
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 3 Vertragsschluss
          </h2>
          <p>
            Die Darstellung der Produkte auf <span className="text-white">kirchero.store</span> stellt kein
            rechtlich bindendes Angebot, sondern eine unverbindliche Aufforderung zur Bestellung dar. Mit
            Klick auf „Im Shop ansehen" wirst du auf unsere Shopify-Verkaufsplattform weitergeleitet, auf der
            der Bestellprozess stattfindet.
          </p>
          <p className="mt-3">
            Durch Anklicken des Bestell-Buttons im Checkout gibst du eine verbindliche Bestellung der im
            Warenkorb befindlichen Waren ab. Die Bestätigung des Eingangs deiner Bestellung erfolgt unmittelbar
            nach Absenden per automatisierter E-Mail. Diese Eingangsbestätigung stellt noch keine
            Vertragsannahme dar. Der Kaufvertrag kommt erst zustande, sobald wir deine Bestellung durch eine
            ausdrückliche Auftragsbestätigung annehmen oder die Ware versenden.
          </p>
          <p className="mt-3">
            Die Vertragssprache ist Deutsch.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 4 Print on Demand & Produktion
          </h2>
          <p>
            Alle Artikel werden nach individueller Bestellung im Print-on-Demand-Verfahren über unseren
            Produktions­partner Gelato APS (Dänemark) hergestellt. Es gibt kein Lager im klassischen Sinn.
            Übliche Bearbeitungszeit: 2–5 Werktage Produktion zzgl. Versanddauer.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 5 Preise & Zahlung
          </h2>
          <p>
            Alle Preise sind Endpreise in Euro inkl. der gesetzlichen Mehrwertsteuer, zzgl. Versandkosten. Die
            akzeptierten Zahlungsmittel werden im Checkout angezeigt (i. d. R. Kreditkarte, PayPal, Klarna,
            Apple Pay, Google Pay, SEPA). Die Zahlung wird über unseren Zahlungspartner Shopify Payments
            abgewickelt.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 6 Versand & Lieferung
          </h2>
          <p>
            Wir versenden in alle Länder, die im Checkout zur Auswahl stehen. Versandkosten und
            voraussichtliche Lieferzeiten werden vor Abschluss der Bestellung angezeigt. Das Risiko des
            zufälligen Untergangs und der zufälligen Verschlechterung der Ware geht bei Verbrauchern erst
            mit Übergabe der Ware an den Kunden, bei Unternehmern mit Übergabe an den Frachtführer auf den
            Käufer über.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 7 Widerrufsrecht für Verbraucher
          </h2>
          <p className="text-white/70 italic mb-3">Widerrufsbelehrung</p>
          <p>
            <strong className="text-white">Widerrufsrecht:</strong> Du hast das Recht, binnen 14 Tagen ohne
            Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag,
            an dem du oder ein von dir benannter Dritter, der nicht der Beförderer ist, die Ware in Besitz
            genommen hat.
          </p>
          <p className="mt-3">
            Um dein Widerrufsrecht auszuüben, musst du uns (VHP Consulting GmbH, Lützner Straße 214,
            04179 Leipzig, E-Mail: kontakt@vhp-consulting.com, Telefon: +49 341 5502441) mittels einer
            eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder E-Mail) über deinen
            Entschluss, diesen Vertrag zu widerrufen, informieren.
          </p>
          <p className="mt-3">
            <strong className="text-white">Folgen des Widerrufs:</strong> Wenn du diesen Vertrag widerrufst,
            haben wir dir alle Zahlungen, die wir von dir erhalten haben, einschließlich der Lieferkosten
            (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass du eine andere Art der
            Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt hast), unverzüglich
            und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über deinen
            Widerruf bei uns eingegangen ist. Du musst die Ware unverzüglich zurücksenden. Die unmittelbaren
            Kosten der Rücksendung trägst du.
          </p>

          <div className="mt-6 border-l-2 border-[#A93043]/60 pl-4 bg-[#A93043]/5 py-3">
            <p className="text-white">
              <strong>Ausschluss des Widerrufsrechts:</strong> Das Widerrufsrecht besteht gemäß
              § 312g Abs. 2 Nr. 1 BGB nicht bei Verträgen zur Lieferung von Waren, die nicht vorgefertigt sind
              und für deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher
              maßgeblich ist oder die eindeutig auf die persönlichen Bedürfnisse des Verbrauchers
              zugeschnitten sind. Da unsere Print-on-Demand-Artikel jeweils erst auf Bestellung individuell
              gefertigt werden, ist das Widerrufsrecht insoweit ausgeschlossen.
            </p>
          </div>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 8 Eigentumsvorbehalt
          </h2>
          <p>
            Bis zur vollständigen Bezahlung bleibt die Ware unser Eigentum.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 9 Gewährleistung
          </h2>
          <p>
            Es gelten die gesetzlichen Mängelhaftungsrechte. Bei Mängeln hast du nach deiner Wahl das Recht
            auf Nacherfüllung in Form der Mangelbeseitigung oder Lieferung einer mangelfreien Sache. Bei
            Fehlschlagen der Nacherfüllung kannst du Minderung des Kaufpreises verlangen oder vom Vertrag
            zurücktreten.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 10 Haftung
          </h2>
          <p>
            Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Schäden aus der Verletzung
            des Lebens, des Körpers oder der Gesundheit. Bei leichter Fahrlässigkeit haften wir nur bei der
            Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), beschränkt auf den vertragstypischen,
            vorhersehbaren Schaden. Eine weitergehende Haftung ist ausgeschlossen.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 11 Anwendbares Recht & Gerichtsstand
          </h2>
          <p>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Für
            Verbraucher gilt diese Rechtswahl nur insoweit, als nicht zwingende Bestimmungen des Staates,
            in dem der Verbraucher seinen gewöhnlichen Aufenthalt hat, entgegenstehen. Gerichtsstand für
            Kaufleute ist Leipzig.
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 12 Streitbeilegung
          </h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungs­verfahren vor einer
            Verbraucher­schlichtungsstelle teilzunehmen. Die EU-Online-Streitbeilegungsplattform findest du
            unter{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noreferrer"
              className="text-[#D4AF37] hover:underline"
            >
              ec.europa.eu/consumers/odr
            </a>
            .
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl uppercase tracking-wider text-[#D4AF37] mb-4">
            § 13 Salvatorische Klausel
          </h2>
          <p>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird hierdurch die
            Wirksamkeit der übrigen Bestimmungen nicht berührt.
          </p>
        </div>

        <p className="text-white/40 text-xs">
          Stand: {new Date().toLocaleDateString("de-DE")}
        </p>
      </section>
    </LegalLayout>
  );
}
